export const ENTRY_TYPE = {
  NATURAL_PERSON: 1,
  LEGAL_ENTITY: 2,
};

export const WATCHLIST_URLS = {
  EveryPolitician: "https://everypolitician.org/",
  PolishPep: "https://www.senat.gov.pl/en/",
  RomanianPep: "http://www.cdep.ro/",
  RomanianPep2016: "http://www.cdep.ro/",
  RomanianPep2020: "http://www.cdep.ro/",
  EstonianPep: "https://www.riigikogu.ee/en/",
  HighRiskCountries: "https://europa.eu/",
  WorldLeadersCIA: "https://www.cia.gov/",
  SwissSecoSanctionList: "https://www.seco.admin.ch/seco/en/home.html",
  NorthMacedonianPep: "https://www.sobranie.mk/",
  SdfmBlacklistUkraine: "https://fiu.gov.ua/en/",
  ParliamentMembersEU: "http://www.europarl.europa.eu/",
  UnitedNationsSecurityCouncilConsolidatedList:
    "https://scsanctions.un.org/search/",
  BulgarianPEP: "https://register.caciaf.bg/2018",
  BulgarianPEP2018: "https://register.caciaf.bg/2018",
  BulgarianPEP2019: "https://register.caciaf.bg/2019",
  BulgarianPEP2020: "https://register.caciaf.bg/2020",
  BulgarianPEP2018y: "https://register.caciaf.bg/2018y",
  BulgarianPEP2019y: "https://register.caciaf.bg/2019y",
  BulgarianPEP2020y: "https://register.caciaf.bg/2020y",
  BulgarianPEP2018f1: "https://register.caciaf.bg/2018f1",
  BulgarianPEP2019f1: "https://register.caciaf.bg/2019f1",
  BulgarianPEP2019e: "https://register.caciaf.bg/2019e",
  BulgarianPEP2018h: "https://register.caciaf.bg/2018h",
  TreasuryConsolidatedSanctionsList: "https://sanctionssearch.ofac.treas.gov/",
  FinancialSanctionConsolidatedListEU: "https://sanctionsmap.eu/",
  Interpol: "https://www.interpol.int/",
  EuTerrorists: "https://eur-lex.europa.eu/",
  NegativeMedia: "https://data.occrp.org/",
};

export const FILTER_LABELS_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES = {
  watchListTypes: "Watchlist Types: ",
  minimumMatchingPercentage: "Match %: ",
  file: "File: ",
};

export const FILTER_LABELS_WATCH_LIST_ENTRIES = {
  firstName: "First name:",
  middleName: "Middle name:",
  lastName: "Last name:",
  type: "Client type:",
  nationalityId: "Nationality:",
  minimumMatchingPercentage: "Match %:",
};

export const ENTITY_TYPE_OPTIONS = [
  { value: 1, label: "Natural person" },
  { value: 2, label: "Legal entity" },
];



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/constants/watchListEntryConstants.js